import { useShortCodeDataCemeteries } from '@/hooks/use-short-code-data/use-short-code-data'
import { FC } from 'react'
import { css } from '@emotion/react'
import { List, ListItem } from '@lifedot/atoms/List'
import { DirectorComment } from '@lifedot/components/DirectorComment'
import { palette } from '@lifedot/styles/palette'
import { typography } from '@lifedot/styles/typography'
import FiberManualRecord from '@material-ui/icons/FiberManualRecord'
import { AddMarginWrapper } from '@lifedot/components/AddMarginWrapper'
import { SubHeading } from '@/components/ShortCode/CemeteryIntroduction/SubHeading'

const styles = {
  fontWeightBold: css({
    fontWeight: 'bold'
  }),
  list: css({
    li: {
      marginTop: 6
    }
  }),
  icon: css({
    color: palette.main
  })
}

interface RecommendPointsProps {
  cemeteryId: number
}

export const RecommendPoints: FC<RecommendPointsProps> = ({ cemeteryId }) => {
  const [cemetery] = useShortCodeDataCemeteries([cemeteryId])
  if (!cemetery) return null
  const { descriptions, director_comment: directorComment, name } = cemetery
  return (
    <section>
      <SubHeading text={`${name}のおすすめポイント`} />
      <AddMarginWrapper spacing={5}>
        <div css={styles.list}>
          {descriptions.length > 0 && (
            <List
              icon={
                <FiberManualRecord style={{ fontSize: 12 }} css={styles.icon} />
              }
            >
              {descriptions.map(({ subject }) => (
                <ListItem key={subject}>
                  <span css={[typography.textL, styles.fontWeightBold]}>
                    {subject}
                  </span>
                </ListItem>
              ))}
            </List>
          )}
        </div>
        <DirectorComment cemeteryId={cemeteryId}>
          {directorComment}
        </DirectorComment>
      </AddMarginWrapper>
    </section>
  )
}
